const configMapa = {
    clickableIcons: true,
    streetViewControl: true,
    panControlOptions: true,
    gestureHandling: "cooperative",
    mapTypeControl: true,
    zoom: 10,
    minZoom: 0,
    maxZoom: 0,
    disableDoubleClickZoom:false
  };
  
  export { configMapa};


// WEBPACK FOOTER //
// ./src/constants/configMapa.js